import { render, staticRenderFns } from "./AlertsPopoutApp.vue?vue&type=template&id=a4fa3526"
import script from "./AlertsPopoutApp.vue?vue&type=script&lang=js"
export * from "./AlertsPopoutApp.vue?vue&type=script&lang=js"
import style0 from "./AlertsPopoutApp.vue?vue&type=style&index=0&id=a4fa3526&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports